export default "__VITE_ASSET__CG3cVAyD__"